// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AddTagToDataItemRequestModel from '../../model/add-tag-to-data-item-request-model';
import AddTagToDataItemRequestDTO from '../dto/add-tag-to-data-item-request-dto';
import dtoSchema from '../schemas/add-tag-to-data-item-request-schema';

export default abstract class AddTagToDataItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AddTagToDataItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.tagId = data.tagId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  tagId?: number;

  static toModel(dto: DeepPartial<AddTagToDataItemRequestDTO>): AddTagToDataItemRequestModel;
  static toModel(dto: DeepPartial<AddTagToDataItemRequestDTO> | undefined | null): AddTagToDataItemRequestModel | undefined;
  static toModel(dto: DeepPartial<AddTagToDataItemRequestDTO> | undefined | null): AddTagToDataItemRequestModel | undefined {
    return dto ? new AddTagToDataItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AddTagToDataItemRequestModel> | AddTagToDataItemRequestModel): AddTagToDataItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      tagId: unwrapped.tagId,
    } as AddTagToDataItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AddTagToDataItemRequestModel, can not map to AddTagToDataItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
